import { INSTANT_EXPEDITIONS, REGULAR_EXPEDITIONS } from '~/shared/expedition'

export const getCourierProps = (code: string) => {
  const couriers = [...REGULAR_EXPEDITIONS, ...INSTANT_EXPEDITIONS]
  return couriers.find((courier) => courier.code === code)
}
